export default `/* Ids Scroll view Component */
.ids-scroll-view {
  display: flex;
  outline: none;
  overflow-x: scroll;
  scroll-snap-type: x mandatory;
  scroll-behavior: smooth;
  -ms-overflow-style: none;
  scrollbar-width: none;
}
.ids-scroll-view::-webkit-scrollbar {
  display: none;
}
.ids-scroll-view ::slotted([slot=scroll-view-item]) {
  flex-shrink: 0;
  scroll-snap-align: start;
  width: 100%;
}
.ids-scroll-view ::slotted([slot=scroll-view-item]) > * {
  display: block;
  margin: var(--ids-space-none);
}
.ids-scroll-view ::slotted(ids-widget) {
  padding: 2px 0 0 4px;
}
.ids-scroll-view.media-circle-pager {
  display: none;
}

.ids-scroll-view-controls {
  display: flex;
  justify-content: center;
  min-height: var(--ids-scroll-view-controls-min-height);
}
.ids-scroll-view-controls.suppress-controls {
  visibility: hidden;
  pointer-events: none;
}
.ids-scroll-view-controls .circle-button [icon] {
  color: var(--ids-scroll-view-color-icon-default);
}
.ids-scroll-view-controls .circle-button.selected [icon] {
  color: var(--ids-scroll-view-color-icon-selected);
}
.ids-scroll-view-controls .circle-button.selected [icon]::part(svg) {
  fill: var(--ids-scroll-view-color-icon-selected);
}

.ids-scroll-view-container.as-nav {
  display: flex;
  align-items: center;
  position: relative;
}
.ids-scroll-view-container.as-nav .ids-scroll-view {
  scroll-snap-type: x mandatory;
  overflow-x: auto;
  display: flex;
  gap: 8px;
  padding: 0 40px;
}
.ids-scroll-view-container.as-nav .ids-scroll-view ::slotted(*) {
  flex: 0 0 auto;
  scroll-snap-align: start;
  width: 100px;
  height: 100px;
  object-fit: cover;
  cursor: pointer;
  box-sizing: border-box;
  border: 1px solid var(--ids-color-border-weaker);
  overflow: hidden;
}
.ids-scroll-view-container.as-nav .ids-scroll-view ::slotted(.selected) {
  border: 1px solid var(--ids-color-action-default);
  box-shadow: 5px 0 5px -2px rgba(0, 114, 237, 0.5);
}
.ids-scroll-view-container.as-nav .scroll-start {
  margin-inline-end: 8px;
}
.ids-scroll-view-container.as-nav .scroll-end {
  margin-inline-start: 8px;
}

:host([object-fit=contain]) .ids-scroll-view ::slotted(*) {
  object-fit: contain;
}

:host([object-fit=cover]) .ids-scroll-view ::slotted(*) {
  object-fit: cover;
}

:host([object-fit=fill]) .ids-scroll-view ::slotted(*) {
  object-fit: fill;
}

:host([object-fit=none]) .ids-scroll-view ::slotted(*) {
  object-fit: none;
}

:host([object-fit=scale-down]) .ids-scroll-view ::slotted(*) {
  object-fit: scale-down;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`;
